import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/medio';

class TransportTypeService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default TransportTypeService;



// WEBPACK FOOTER //
// ./src/services/TransportTypeService.js